export default {
   'features': 'Features',
   'downloads': 'Downloads',
   'roadmap': 'Roadmap',
   'price': 'Price',
   'donate': 'Donate',
   'feedback': 'Feedback',
   'panel': 'Control Panel',
};